export default __webpack_public_path__ + "static/media/1.d164d1d4.png";